module.exports = "<div class=\"sla_list_item {{selected}}\"><div class=\"text_item\">{{text}}</div></div>";